enum Hotkey {
    Up = 'UP',
    Down = 'DOWN',
    Left = 'LEFT',
    Right = 'RIGHT',
    ActionX1 = 'ACTION_X_1', // Run
    ActionX2 = 'ACTION_X_2', // Reset
    ActionX3 = 'ACTION_X_3', // Hide
    ActionX4 = 'ACTION_X_4', // Dynamic variable toggle
    ActionX5 = 'ACTION_X_5', // Selected profile toggle
    ActionY1 = 'ACTION_Y_1', // Quit
    MoveAppUp = 'MOVE_APP_UP',
    MoveAppDown = 'MOVE_APP_DOWN',
    MoveAppLeft = 'MOVE_APP_LEFT',
    MoveAppRight = 'MOVE_APP_RIGHT',
}

const DeprecatedHotkeys = {
    Solve: 'ACTION_X_1',
    Reset: 'ACTION_X_2',
    Hide: 'ACTION_X_3',
    Quit: 'ACTION_Y_1',
    ChangeLanguage: 'ACTION_X_4',
};

export { Hotkey, DeprecatedHotkeys };
